import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
interface CinematicHeaderProps {
  onNavigate: (page: string) => void;
  currentPage: string;
}
export function CinematicHeader({
  onNavigate,
  currentPage
}: CinematicHeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Home', 'Experience', 'Menu', 'Events', 'Gallery'];
  const handleNavClick = (link: string) => {
    onNavigate(link.toLowerCase());
    setIsMobileMenuOpen(false);
    window.scrollTo(0, 0);
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-md py-4' : 'bg-transparent py-6'}`} data-id="element-10">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between" data-id="element-11">
          <button onClick={() => handleNavClick('home')} className="text-gold font-serif tracking-ultra-wide font-bold text-[22px] md:text-[26px] z-50 hover:opacity-80 transition-opacity" data-id="element-12">
            TEMPOO
          </button>

          <nav className="hidden md:flex items-center gap-8" data-id="element-13">
            {navLinks.map(link => {
            const isActive = currentPage === link.toLowerCase();
            return <button key={link} onClick={() => handleNavClick(link)} className={`font-sans uppercase tracking-widest text-base font-medium transition-colors duration-300 ${isActive ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-14">
                  {link}
                </button>;
          })}
            <button className="border border-gold text-gold px-6 py-2 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 hover:animate-glow transition-all duration-300" data-id="element-15">
              Reserve Now
            </button>
          </nav>

          <button className="md:hidden text-gold z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-16">
            {isMobileMenuOpen ? <XIcon size={28} data-id="element-17" /> : <MenuIcon size={28} data-id="element-18" />}
          </button>
        </div>
      </header>

      <div className={`fixed inset-0 bg-black z-40 flex flex-col items-center justify-center transition-opacity duration-500 ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} data-id="element-19">
        <nav className="flex flex-col items-center gap-8" data-id="element-20">
          {navLinks.map(link => {
          const isActive = currentPage === link.toLowerCase();
          return <button key={link} onClick={() => handleNavClick(link)} className={`font-sans uppercase tracking-mega-wide text-xl font-medium transition-colors duration-300 ${isActive ? 'text-gold' : 'text-white hover:text-gold'}`} data-id="element-21">
                {link}
              </button>;
        })}
          <button className="mt-8 border border-gold text-gold px-8 py-3 font-sans uppercase tracking-widest text-base font-medium hover:bg-gold/10 transition-all duration-300" data-id="element-22">
            Reserve Now
          </button>
        </nav>
      </div>
    </>;
}